const getQueryStringValue = (key: string, value: string) => {
    // Temporary workaround to fix the issue with the email filter (GP-11882)
    if (key === "contactMainEmail") {
        return `${key}=${encodeURIComponent(`%${value}`)}`;
    }

    return `${key}=${encodeURIComponent(value)}`;
};

const arrayToQueryStringValue = (key: string, values: string[]) =>
    values.map((value) => getQueryStringValue(key, value)).join("&");

export const objectToQueryQuestionMark = (object: Record<string, unknown>) => {
    if (Object.keys(object).length) {
        const queryString = Object.entries(object)
            .filter(([, value]) => value !== undefined && value !== null && value !== "")
            .map(([key, value]) =>
                Array.isArray(value)
                    ? arrayToQueryStringValue(key, value as string[])
                    : getQueryStringValue(key, value as string)
            )
            // Sorting avoid test to fail caused by mismatch url
            .sort();

        return `?${queryString.join("&")}`;
    }

    return "";
};
